import { Box, Button, Card, Flex, Skeleton, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import backgroundImage from "../../../assets/illustrations/plan-switcher-car.svg";
import { TextSerif } from "../TextSerif";

import { IconArrowRight } from "@/components/icons";

import type { FC } from "react";

interface Props {
  titleCard: string;
  descriptionCard: string;
  buttonText?: string;
  onClick: () => void;
  isLoading: boolean;
}

export const PlanSwitcherCard: FC<Props> = ({
  titleCard,
  descriptionCard,
  buttonText,
  onClick,
  isLoading,
}) => {
  const { t } = useTranslation();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const bgCard = isDark ? "#0b0a0a" : "#444444";

  const hexToRgba = (hex: string, alpha: number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const heightCard = { base: 180, sm: 160 };

  return (
    <>
      <Skeleton visible={isLoading} radius="md" h={heightCard}>
        <Card
          h={heightCard}
          style={{
            backgroundColor: bgCard,
            backgroundImage: `linear-gradient(93deg,
              ${hexToRgba(bgCard, isDark ? 0.7 : 0.7)} 5%,
              ${isDark ? hexToRgba(bgCard, 1) : "rgba(0,0,0,0.95)"} 100%
            ), url(${backgroundImage})`,

            backgroundRepeat: "no-repeat",
            backgroundPosition: "left bottom",
            backgroundSize: "cover",
          }}
        >
          <Flex direction="column" h="100%" p="md" justify="space-between">
            <Box>
              <Text c="#ffffff" fz="1.125em" fw={500} mb="xs">
                {titleCard}
              </Text>
              <TextSerif c="#f7f8fa" fz="xs" fw="lighter" maw={350} lh="1.25">
                {descriptionCard}
              </TextSerif>
            </Box>
            <Flex justify="end" mt={{ base: "sm", sm: 0 }}>
              <Button
                c="dark"
                variant="white"
                w={150}
                miw="fit-content"
                rightSection={<IconArrowRight />}
                onClick={onClick}
                disabled={isLoading}
                aria-label={buttonText || t("plans.planSwitcherCard.upgradeText")}
              >
                {buttonText || t("plans.planSwitcherCard.upgradeText")}
              </Button>
            </Flex>
          </Flex>
        </Card>
      </Skeleton>
    </>
  );
};
